import { ReactElement, Suspense } from "react";
import { ComponentContentProps } from "../../../data/transformer/componentTransformer.ts";
import { ComponentMap } from "./ComponentsMap.ts";
import { ComponentRendererFallback } from "./ComponentRenderer.fallback.tsx";

type AsyncComponentProps = {
  item: ComponentContentProps;
};

export function AsyncComponent({
  item,
}: AsyncComponentProps): ReactElement | null {
  const Component = ComponentMap[item.type];

  if (!Component) {
    if (process.env.NODE_ENV === "production") {
      return null;
    }

    return (
      <ComponentRendererFallback
        title={item?.error ?? `Component not fount: ${item.type}`}
      />
    );
  }

  return (
    <Suspense>
      {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
      <Component {...(item.data as any)} />
    </Suspense>
  );
}
